export function ProductRoutePending() {
  return (
    <main id="main" data-shell-page tabIndex={-1}>
      <output>Opening page…</output>
    </main>
  );
}
